import Axios, { AxiosResponse } from 'axios';
import router from '../router';
import store from '../store';
import { AxiosRequestConfig } from 'axios';
const blackApiList: string[] = [];
const baseConfig: AxiosRequestConfig = {
    baseURL: store.state.API_ROOT,
};
const axios = Axios.create(baseConfig);
const ifAddAuthorization = (config: any): AxiosRequestConfig => {
    const token = localStorage.getItem('token');
    if (token && typeof (token) === 'string' && token !== 'undefined') {
        const url = config.url;
        let isBlack = false;
        for (const api of blackApiList) {
            if (url && url.includes(api)) {
                isBlack = true;
            }
        }
        if (isBlack) {
            delete config.headers.common.Authorization;
        } else {
            config.headers.common.Authorization = '' + 'Bearer ' + token;
        }
    } else {
        console.log(token);
    }
    return config;
};
axios.interceptors.request.use((config: AxiosRequestConfig) => {
    config = ifAddAuthorization(config);
    return config;
});

axios.interceptors.response.use((value: AxiosResponse) => {
    return value;
}, (error: any) => {
    console.log(error);
});

export default axios;

const resHandle = (VueComponent: any, data: any, loading?: any) => {
    return new Promise((resolve, reject) => {
        if (data.error_code !== 0) {
            if (data.error_code === 401) {
                VueComponent.$message({
                    type: "error",
                    message: data.msg
                });
                if (loading) {
                    loading.close();
                }
                localStorage.removeItem("token");
                router.push("/access/login");
                reject(data.msg);
            } else {
                VueComponent.$message({
                    type: "error",
                    message: data.msg
                });
                if (loading) {
                    loading.close();
                }
                reject(data.msg);
            }
        } else {
            resolve(data);
        }
    });
};

export { resHandle };
